/* List view of runs */
import React from 'react';
import { Link } from 'react-router-dom';
import {Aux, BASE_URL, IsInRole, isNullEmptyOrWhitespace, ROLE_Driver} from '../../constants';
import PropTypes from 'prop-types';
import moment from 'moment';
import {PickupNoteSummary} from "../Pickups/PickupNoteSummary";
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from "../../utils/collectionTypes";

const DriverRunsView = (props) => {
    let {runs, loadRuns, userName, account} = props;

    if (!runs.loaded) {
        return (<div>
            <h5>Loading runs... <i className="fa fa-cog fa-spin fa-2x"/></h5>
        </div>);
    }

    return (<Aux>
        <div className="row mb-2">
            <div className="col-8">
                <h5>
                    <strong>Hi {userName.charAt(0).toUpperCase() + userName.slice(1)}, currently you have {runs.items.length} run{runs.items.length === 1 ? '' : 's'}</strong>                    
                </h5>
            </div>
            <div className="col-4 text-right">
                <button type="button" className="btn btn-primary" onClick={loadRuns}><i className="fa fa-refresh"/>&nbsp;Reload</button>
            </div>
        </div>
        {runs.items.map((run, index) =>
            (<div className="row" key={run.id}>
                <div className="col-12">
                    <div className="card" style={getRunTypeCardStyle(run.truckCollectionTypeCode)}>
                        <div className="card-block">
                            <h5 className="card-title">
                                {run.isComplete && <span className="badge badge-success">Run Complete</span>}
                                {!run.isComplete && <span className="badge badge-warning">Run Incomplete</span>}
                                <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'}><i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}</span>
                                {run.dateModified !== '0001-01-01T00:00:00' &&
                                <span className="text-muted pull-right" style={{fontSize: 'small'}}><i
                                    className="fa fa-save"/>&nbsp;{moment(run.dateModified).format('ddd, Do, LT')}</span>}
                            </h5>
                            <h6>{run.runDate}</h6>
                            <h6>Run {index+1} of {runs.items.length}</h6>
                            <h4><Link style={{padding: 0}} to={`${BASE_URL}/runs/driver/${run.id}`}
                                      className="nav-link">{run.regionsVisited} - {run.truckName}</Link></h4>
                            <h6><strong>Driver:</strong> {run.driverFullName}</h6>
                            <p className="card-text"><i
                                className="fa fa-shopping-cart"/>&nbsp; {`${parseFloat(run.totalLitres).toFixed(0)} L to be ${getCollectionAction(run.truckCollectionTypeCode)}`}
                            </p>
                            <p className="card-text"><i
                                className="fa fa-battery-full"/>&nbsp; {`${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L ${getCollectionAction(run.truckCollectionTypeCode)}`}
                            </p>
                            <p className="card-text"><i
                                className="fa fa-tachometer"/>&nbsp; {`${run.pickupsComplete}/${run.pickupsToComplete}`} locations
                                complete</p>
                            {(run.pickupsToComplete - run.pickupsComplete === 0) && run.isBaseCheckedIn && !run.isBaseCheckedOut &&
                            <p className="card-text text-danger"><i className="fa fa-warning"/> Must check out of final
                                location</p>}
                            <div>
                                {run.pickups.map(p => !p.smsNoResponse && IsInRole(account, ROLE_Driver) 
                                && <PickupNoteSummary key={p.id} pickup={p} />)}
                            </div>
                            {run.lastPickupDate && <p>
                                <span className="font-weight-bold text-primary">Last checkin: </span>
                                <span>{moment(run.lastPickupDate).format('ddd, Do, LT')}</span>
                            </p>}
                        </div>
                    </div>
                </div>
            </div>))}

    </Aux>);
};

DriverRunsView.propTypes = {
    runs: PropTypes.object.isRequired,
    loadRuns: PropTypes.func.isRequired,
    userName: PropTypes.string.isRequired,
};

export default DriverRunsView;
